/**
 * @swagger
 *  components:
 *    schemas:
 *      Product:
 *        type: string
 *        description: |
 *          The product in use.
 *
 *          `bluebird` - Bluebird system.
 *        enum:
 *          - bluebird
 */
/**
 * The product in use
 */
export enum Product {
  /**
   * Bluebird systems
   *
   * It's the representation of Sioslife products as they are designed to be.
   * It's our main branch, main features, main product.
   */
  Bluebird = 'bluebird',
}
